import './CaseStudyFilter.scss'

import React, { FunctionComponent } from 'react'
import Select, { components, IndicatorProps } from 'react-select'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import { dt } from 'Shared/utils/dynamicRS'
import { t } from 'ttag'

import {
  FilterInputType,
  getDataByKey,
  getLocalizedSelectValue,
  SelectOptionType,
} from '../PuxRepeater'

const rootClass = `casestudy-filter`

const DropdownIndicator: FunctionComponent<
  IndicatorProps<SelectOptionType, false>
> = (props) => (
  <components.DropdownIndicator {...props}>
    <PuxIcon
      name={
        props.selectProps.menuIsOpen ? `arrows/up-arrow` : `arrows/down-arrow`
      }
      size={16}
      decorative
    />
  </components.DropdownIndicator>
)

const getSelectClassName = (value?: string) =>
  `react-select-container${value ? ` is-filled` : ``}`

const CaseStudyFilter: FunctionComponent<FilterInputType> = (props) => {
  const data = props.completeData

  const rsIndustry = dt(`Pux.RepeaterFilter.CaseStudy.Industry`)
  const rsCountry = dt(`Pux.RepeaterFilter.CaseStudy.Country`)
  const rsCompanySize = dt(`Pux.RepeaterFilter.CaseStudy.CompanySize`)

  const industryData = getDataByKey(data, `caseStudyIndustry`, rsIndustry)
  const countryData = getDataByKey(data, `caseStudyCountry`, rsCountry)
  const companySizeData = getDataByKey(
    data,
    `caseStudyCompanySize`,
    rsCompanySize
  )

  props.setBindingTable({
    'filter-industry': {
      field: `caseStudyIndustry`,
    },
    'filter-country': {
      field: `caseStudyCountry`,
    },
    'filter-companysize': {
      field: `caseStudyCompanySize`,
    },
  })

  return (
    <div className={`pux-repeater-filter ${rootClass}-wrapper`}>
      <div className={`pux-repeater-filter-item`}>
        <label htmlFor='filter-industry'>
          {t`Pux.RepeaterFilter.CaseStudy.Industry.Label`}
        </label>
        <Select
          inputId='filter-industry'
          name='filter-industry'
          className={getSelectClassName(
            props.activeFilters[`caseStudyIndustry`]
          )}
          classNamePrefix='react-select'
          components={{ DropdownIndicator }}
          value={getLocalizedSelectValue(
            props.activeFilters[`caseStudyIndustry`],
            `Pux.RepeaterFilter.CaseStudy.Industry`
          )}
          options={industryData}
          onChange={(selectedOption) =>
            props.updateUrl(
              selectedOption ? selectedOption.value : ``,
              `filter-industry`
            )
          }
        />
      </div>
      <div className={`pux-repeater-filter-item`}>
        <label htmlFor='filter-country'>
          {t`Pux.RepeaterFilter.CaseStudy.Country.Label`}
        </label>
        <Select
          inputId='filter-country'
          name='filter-country'
          className={getSelectClassName(
            props.activeFilters[`caseStudyCountry`]
          )}
          classNamePrefix='react-select'
          components={{ DropdownIndicator }}
          value={getLocalizedSelectValue(
            props.activeFilters[`caseStudyCountry`],
            `Pux.RepeaterFilter.CaseStudy.Country`
          )}
          options={countryData}
          onChange={(selectedOption) =>
            props.updateUrl(
              selectedOption ? selectedOption.value : ``,
              `filter-country`
            )
          }
        />
      </div>
      <div className={`pux-repeater-filter-item`}>
        <label htmlFor='filter-companysize'>
          {t`Pux.RepeaterFilter.CaseStudy.CompanySize.Label`}
        </label>
        <Select
          inputId='filter-companysize'
          name='filter-companysize'
          className={getSelectClassName(
            props.activeFilters[`caseStudyCompanySize`]
          )}
          classNamePrefix='react-select'
          components={{ DropdownIndicator }}
          value={getLocalizedSelectValue(
            props.activeFilters[`caseStudyCompanySize`],
            `Pux.RepeaterFilter.CaseStudy.CompanySize`
          )}
          options={companySizeData}
          onChange={(selectedOption) =>
            props.updateUrl(
              selectedOption ? selectedOption.value : ``,
              `filter-companysize`
            )
          }
        />
      </div>
      <div
        className={`pux-repeater-filter-item pux-repeater-filter-item--clear`}
      >
        <button
          type='button'
          className='clear-button'
          onClick={props.clearFilter}
        >
          <span className='clear-button-text'>{t`Pux.RepeaterFilter.ClearAll`}</span>
          <PuxIcon name='arrows/refresh' size={24} decorative />
        </button>
      </div>
    </div>
  )
}

export default CaseStudyFilter
